import { createAsyncThunk } from '@reduxjs/toolkit';

import { auth } from 'endpoints/index';
import { ApiResponse } from 'endpoints/endpoint';
import { auth as firebaseAuth } from 'firebase-service/firebase-client';

export const signOut = createAsyncThunk<
  ApiResponse<auth.SessionOutResult, auth.SessionOutError>,
  auth.SessionOutParams,
  { rejectValue: string }
>('client/signOut', async (data, { rejectWithValue }) => {
  try {
    const response = await auth.sessionOut(data).invoke();

    if (response.success) {
      await firebaseAuth.signOut();
      return response;
    }

    throw new Error('SignOutError');
  } catch (e) {
    return rejectWithValue((e as Error).message);
  }
});
